import { render, staticRenderFns } from "./choseRole.vue?vue&type=template&id=27ecfac7&scoped=true&"
import script from "./choseRole.vue?vue&type=script&lang=js&"
export * from "./choseRole.vue?vue&type=script&lang=js&"
import style0 from "./choseRole.vue?vue&type=style&index=0&id=27ecfac7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecfac7",
  null
  
)

export default component.exports